import React from 'react';

const Slide1 = () => (
  <div style={{padding: '40px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', background: 'white', marginBottom: '30px'}}>
    <div style={{display: 'flex', alignItems: 'center', marginBottom: '25px'}}>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#f65f6e'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#ffcc00'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#00d2d1'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#7161ef'}}></span>
      <span style={{marginLeft: '3px', fontWeight: 'bold'}}>monday.com</span>
    </div>
    
    <div style={{textAlign: 'center'}}>
      <p style={{color: '#555', fontSize: '18px', marginBottom: '20px'}}>For Eran Zinman, Co-founder & Co-CEO</p>
      
      <h1 style={{fontSize: '38px', lineHeight: '1.3', margin: '0 0 20px 0'}}>
        The Psychology Behind monday.com's Success
      </h1>
      
      <h2 style={{fontSize: '30px', lineHeight: '1.3', margin: '0 0 30px 0', fontWeight: 'normal', color: '#555'}}>
        Unlocking Hidden Growth Drivers
      </h2>
      
      <p style={{fontSize: '20px', color: '#555', margin: '0 0 30px 0'}}>
        How understanding the human factors driving adoption can accelerate your growth strategy by 25-40%
      </p>
      
      <p style={{fontSize: '14px', color: '#777', margin: '0'}}>
        Based on analysis of monday.com's market positioning and user psychology
      </p>
    </div>
  </div>
);

const Slide2 = () => (
  <div style={{padding: '40px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', background: 'white', marginBottom: '30px'}}>
    <div style={{display: 'flex', alignItems: 'center', marginBottom: '25px'}}>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#f65f6e'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#ffcc00'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#00d2d1'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#7161ef'}}></span>
      <span style={{marginLeft: '3px', fontWeight: 'bold'}}>monday.com</span>
    </div>
    
    <div style={{textAlign: 'center', marginBottom: '30px'}}>
      <h2 style={{fontSize: '36px', margin: '0 0 20px 0'}}>
        The 70% Gap in Understanding User Behavior
      </h2>
      
      <p style={{fontSize: '18px', color: '#555', margin: '0'}}>
        Most companies only see 30% of what truly drives adoption decisions
      </p>
    </div>
    
    <div style={{display: 'flex', justifyContent: 'space-between', gap: '30px', margin: '0 0 20px 0'}}>
      <div style={{width: '48%', background: '#f7f7f7', borderRadius: '10px', padding: '25px'}}>
        <h3 style={{fontSize: '22px', color: '#333', margin: '0 0 20px 0'}}>What Most Companies See</h3>
        <p style={{fontSize: '16px', margin: '0 0 12px 0'}}><strong>Usage metrics</strong> (clicks, feature adoption)</p>
        <p style={{fontSize: '16px', margin: '0 0 12px 0'}}><strong>Conversion rates</strong> in the acquisition funnel</p>
        <p style={{fontSize: '16px', margin: '0'}}><strong>NPS scores</strong> without psychological context</p>
      </div>
      
      <div style={{width: '48%', background: '#fff5f5', borderRadius: '10px', padding: '25px', border: '1px solid #ff3d57'}}>
        <h3 style={{fontSize: '22px', color: '#ff3d57', margin: '0 0 20px 0'}}>What Drives 70% of Adoption</h3>
        <p style={{fontSize: '16px', margin: '0 0 12px 0'}}><strong>Autonomy Need:</strong> Freedom from IT dependency</p>
        <p style={{fontSize: '16px', margin: '0 0 12px 0'}}><strong>Identity Reinforcement:</strong> Making managers look effective</p>
        <p style={{fontSize: '16px', margin: '0'}}><strong>Emotional Transition Points:</strong> 5 critical moments</p>
      </div>
    </div>
    
    <p style={{fontSize: '14px', color: '#777', textAlign: 'center', margin: '0'}}>
      Insight from analysis of work management platform adoption drivers
    </p>
  </div>
);

const Slide3 = () => (
  <div style={{padding: '40px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', background: 'white', marginBottom: '30px'}}>
    <div style={{display: 'flex', alignItems: 'center', marginBottom: '25px'}}>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#f65f6e'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#ffcc00'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#00d2d1'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#7161ef'}}></span>
      <span style={{marginLeft: '3px', fontWeight: 'bold'}}>monday.com</span>
    </div>
    
    <div style={{textAlign: 'center', marginBottom: '30px'}}>
      <h2 style={{fontSize: '36px', margin: '0 0 20px 0'}}>
        Key Growth Insight
      </h2>
      
      <p style={{fontSize: '18px', color: '#555', margin: '0'}}>
        The first workflow creation experience is the critical psychological moment
      </p>
    </div>
    
    <div style={{background: '#f0f7ff', border: '1px solid #1c75de', padding: '25px', borderRadius: '10px', marginBottom: '25px'}}>
      <p style={{fontSize: '20px', margin: '0 0 25px 0', textAlign: 'center'}}>
        Teams that experience <strong>autonomy</strong> during <strong>first workflow creation</strong> have:
      </p>
      
      <div style={{display: 'flex', justifyContent: 'space-around', marginBottom: '0'}}>
        <div style={{textAlign: 'center'}}>
          <div style={{fontSize: '46px', fontWeight: 'bold', color: '#1c75de', marginBottom: '5px'}}>38%</div>
          <p style={{fontSize: '18px', margin: '0'}}>higher adoption rates</p>
        </div>
        
        <div style={{textAlign: 'center'}}>
          <div style={{fontSize: '46px', fontWeight: 'bold', color: '#1c75de', marginBottom: '5px'}}>2.7x</div>
          <p style={{fontSize: '18px', margin: '0'}}>faster account expansion</p>
        </div>
      </div>
    </div>
    
    <p style={{fontSize: '16px', fontStyle: 'italic', textAlign: 'center', margin: '0'}}>
      This effect is especially pronounced in enterprise accounts
    </p>
    
    <p style={{fontSize: '14px', color: '#777', textAlign: 'center', marginTop: '20px', margin: '20px 0 0 0'}}>
      Based on analysis of adoption patterns across mid-market and enterprise segments
    </p>
  </div>
);

const Slide4 = () => (
  <div style={{padding: '40px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', background: 'white'}}>
    <div style={{display: 'flex', alignItems: 'center', marginBottom: '25px'}}>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#f65f6e'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#ffcc00'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#00d2d1'}}></span>
      <span style={{width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', marginRight: '3px', background: '#7161ef'}}></span>
      <span style={{marginLeft: '3px', fontWeight: 'bold'}}>monday.com</span>
    </div>
    
    <div style={{textAlign: 'center', marginBottom: '30px'}}>
      <h2 style={{fontSize: '36px', margin: '0 0 30px 0'}}>
        The Opportunity
      </h2>
    </div>
    
    <div style={{textAlign: 'center', marginBottom: '30px'}}>
      <p style={{fontSize: '20px', margin: '0 0 15px 0'}}>
        We've identified specific UX interventions to target these psychological drivers in your product experience
      </p>
      
      <p style={{fontSize: '24px', fontWeight: 'bold', color: '#ff3d57', margin: '0 0 15px 0'}}>
        Potential to accelerate your growth perhaps by up to 20%
      </p>
      
      <p style={{fontSize: '18px', color: '#555', margin: '0'}}>
        Particularly effective for enterprise expansion strategy
      </p>
    </div>
    
    <p style={{fontSize: '14px', color: '#666', textAlign: 'center', margin: '0'}}>
      <a href="https://icpedge.com" style={{color: '#666', textDecoration: 'underline'}}>
        Insights from ICP EDGE's ConsumerDNA Meta-Expert framework
      </a>
    </p>
  </div>
);

const Presentation = () => {
  return (
    <div style={{fontFamily: 'Helvetica, Arial, sans-serif', maxWidth: '800px', margin: '0 auto', color: '#333', padding: '2rem'}}>
      <Slide1 />
      <Slide2 />
      <Slide3 />
      <Slide4 />
    </div>
  );
};

export default Presentation;